module.exports = __webpack_public_path__ + "img/investment_8.8b25e050.jpg";